/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions || [];

  return {
    canUser: currentUser && permissions.includes('USER_MANAGER'),
    canRole: currentUser && permissions.includes('ROLE_MANAGER'),
    canBanner: currentUser && permissions.includes('BANNER_MANAGER'),
    canCategory: currentUser && permissions.includes('CATEGORY_MANAGER'),
    canNew: currentUser && permissions.includes('NEW_MANAGER'),
    canCustomer: currentUser && permissions.includes('CUSTOMER_MANAGER'),
    canTicket: currentUser && permissions.includes('TICKET_MANAGER'),
  };
}
